import { Injectable } from '@angular/core'
import { AngularFirestore, QueryFn } from 'angularfire2/firestore'
import { ApiService } from './api.service'

@Injectable()
export class FirestoreService {

  constructor(
    public firestore: AngularFirestore
  ) { }

  id () { return this.firestore.createId() }

  batch () { return this.firestore.firestore.batch() }
  transaction (updateFunction) { return this.firestore.firestore.runTransaction(updateFunction)}

  enableNetwork () { return this.firestore.firestore.enableNetwork() }
  disableNetwork () { return this.firestore.firestore.disableNetwork() }

  fireDoc (path) { return this.firestore.firestore.doc(path) }
  fireCol (path) { return this.firestore.firestore.collection(path) }

  fromDomain <T = any>(doc: string) {
    return this.firestore.collection('domain').doc<T>(doc)
  }

  fromDomainObservable<T = any> (doc: string) {
    return this.fromDomain<T>(doc).valueChanges()
  }

  fromDomainPromise<T = any> (doc: string) {
    return this.fromDomainObservable<T>(doc).toPromise()
  }

  async fromDomainAsync<T = any> (doc: string) {
    return await this.fromDomain<T>(doc)
  }

  doc<T = any> (path: string, decryptFields?: (string | [string, 'parse' | 'flatten' | 'flatParse' | 'none'])[]) {
    return this.firestore.doc<T | { [k: string]: string }>(path).valueChanges().map(document =>
      document && decryptFields ?
        Object.assign.apply(null, [document].concat(decryptFields.map(k =>
          Array.isArray(k) ?
          document[k[0]] ?
            {
              [k[0]]: {
                parse: value => JSON.parse(value),
                flatten: value => Object.assign(document, value),
                flatParse: value => Object.assign(document, JSON.parse(value)),
                none: value => value
              }[k[1] || 'none'](ApiService.secure.decrypt(document[k[0]]))
            } :
            {} :
          document[k] ? { [k]: ApiService.secure.decrypt(document[k]) } : {}
        ))) :
        document
    )
  }

  col<T = any> (path: string, decryptFields?: (string | [string, 'parse' | 'flatten' | 'flatParse' | 'none'])[], query?: QueryFn) {
    return this.firestore.collection<T>(path, query).snapshotChanges()
    .map(snaps =>
      snaps.map(snap => Object.assign({}, snap.payload.doc.data(), { id: snap.payload.doc.id }))
    )
    .map((documents: any) =>
      documents && decryptFields ?
        documents.map(document =>
          Object.assign.apply(null, [document].concat(decryptFields.map(k =>
            Array.isArray(k) ?
            document[k[0]] ?
              {
                [k[0]]: {
                  parse: value => JSON.parse(value),
                  flatten: value => Object.assign(document, value),
                  flatParse: value => Object.assign(document, JSON.parse(value)),
                  none: value => value
                }[k[1] || 'none'](ApiService.secure.decrypt(document[k[0]]))
              } :
              {} :
            document[k] ? { [k]: ApiService.secure.decrypt(document[k]) } : {}
          )))
        ) :
        documents
    )
  }

}
